import Vue from "vue";

// import RtHeader from "../packages/header/src/main";
// import RtContent from "../packages/content/src/main";
import RtToolbar from "../packages/toolbar/src/main";
//新增
import RtPlatHeader from "../packages/header/src/main";
import RtSassGrid from './sass-grid/src/main.vue';
import RtPlatLookup from '../packages/lookup/src/plat-lookup';
import RtFlowSubmit from './flowsubmit/src/flow-submit.vue';
import RtFlowApprovalList from './flowsubmit/src/flow-approval-list.vue';
import RtFlowApporvalDialog from './flowsubmit/src/flow-approval-dialog.vue';
// import RtQuery from "../packages/query/src/main";
import RtGrid from "../packages/grid/src/main";
import RtPicklist from "../packages/picklist/src/main";
// import RtButton from "../packages/button/src/main";
// import RtSection from "../packages/section/src/main";
// import RtNav from "../packages/nav/src/nav";
// import RtNavItem from "../packages/nav/src/nav-item";
import RtPortalIcon from "../packages/icon/index";
//Lookup
import RtLookup from "../packages/lookup/src/lookup";
import RtLookupDialog from "../packages/lookup/src/lookup-dialog";
//Excel导入
import RtExcelImportDialog from "../packages/excel-import/src/excel-import-dialog";
import RtExcelImport from "../packages/excel-import/src/excel-import";
//流程提交
import RtFlowSubmitDialog from "../packages/flow/src/submit-dialog";
//审批进度
import RtApprovalProgress from "../packages/approval/src/progress";
import RtApprovalProgressDialog from "../packages/approval/src/progress-dialog";

import RtFileList from "./file/src/file-list";
import XpcComponents from "vue-xpc/src/components";

var components = [
    // RtHeader,
    // RtContent,
    RtToolbar,
    RtPlatHeader, RtSassGrid, RtPlatLookup, RtFlowSubmit, RtFlowApprovalList, RtFlowApporvalDialog,
    // RtQuery,
    RtGrid,
    RtPicklist,
    // RtButton,
    // RtSection,
    // RtNav,
    // RtNavItem,
    RtLookup,
    RtLookupDialog,
    RtExcelImportDialog,
    RtExcelImport,
    RtFlowSubmitDialog,
    RtApprovalProgress,
    RtApprovalProgressDialog,
    RtFileList,
    RtPortalIcon
];

export default {
    install: function(Vue, opts) {
        components.map(function(component) {
            Vue.component(component.name, component);
        });
    },
};


//////////////////
// WEBPACK FOOTER
// ./packages/index.js
// module id = 2220
// module chunks = 228